export default __webpack_public_path__ + "static/media/Comfortaa-Light.5ff4d1fc.ttf";